import React from 'react'
import { PrivacyPolicyModalView } from 'containers/createAccount/components/privacyPolicyModal/PrivacyPolicyModalView'

export const usePrivacyPolicyModal = (isOpen: boolean, setIsOpen: (value: boolean) => void) => {
  const handleHide = () => setIsOpen(false)

  const handlePrivacyPolicyModalOpen = (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()
    setIsOpen(true)
  }

  return {
    PrivacyPolicyModal: isOpen ? <PrivacyPolicyModalView isOpen={isOpen} handleHide={handleHide} /> : null,
    handlePrivacyPolicyModalOpen,
  }
}
